import React, { useState, useEffect } from "react";
import { View, Dimensions } from "react-native";
import { useRecoilState, useRecoilValue } from "recoil";
import { useIsFocused } from "@react-navigation/native";
import {
  getAllcompetitions,
  conditioncheck,
  cancelPost,
} from "../../action/authAction";
import Login from "../login";
import { styles } from "./style";
import { tokenState, userState } from "../../reducer/recoil";
const { width, height } = Dimensions.get("window");
export default function index({ navigation, route }) {
  const [data, setData] = useState([]);
  const [count, setCount] = useState(0);
  const [Associationdata, AssociationsetData] = useState([]);
  const [token, setToken] = useRecoilState(tokenState);
  const user = useRecoilValue(userState);
  const [modalVisible, setModalVisible] = useState(false);
  function onModalShow() {
    setModalVisible(true);
    setTimeout(() => {
      setModalVisible(false);
    }, 2000);
  }

  useEffect(() => {
    if (count == 0) {
      if (user.profile != undefined && user.profile.Association != undefined) {
        setCount(1);
        callFunc();
      }
    }
  }, [user]);

  const callFunc = async () => {
    const cancel = await cancelPost(token.token);
    const response = await getAllcompetitions(token.token);
    console.log("token >> ", response);
    console.log("token >> ", user);
    AssociationsetData(
      response.associations.filter(
        (e) => e.association_id == route.params.association_id
      )
    );
    setTimeout(() => {
      setData(response.competitions);
      console.log(route.params.type);
      if (route.params.type == "final") {
        response.associations
          .filter((e) => e.association_id == route.params.association_id)
          .map((items, idexs) => {
            let itemArr = items.Approbations.filter((i) => {
              return route.params.competition_id == i.competition_id;
            })[0];

            navigation.navigate("FinalEntryUser", {
              ...response.competitions.filter(
                (val) => val.competition_id == route.params.competition_id
              )[0],
              ...itemArr,
            });
          });
      } else {
        navigation.navigate(
          "PrelimEntry",
          response.competitions.filter(
            (val) => val.competition_id == route.params.competition_id
          )[0]
        );
      }
    }, 300);
  };

  async function conditioncheckApi(item) {
    const response = await conditioncheck({
      body: {
        association_id: user.profile.Association.association_id,
        competition_id: item.competition_id,
      },
      token: token.token,
    });
    if (response) {
      if (response.result == true) {
        navigation.navigate("PrelimEntry", item);
      } else {
        onModalShow();
      }
    }
  }

  return (
    <View style={styles.container}>
      <Login navigation={navigation} />
    </View>
  );
}
